import { useState, useEffect } from "react";
import { withTranslation, Trans, useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Toast from "react-bootstrap/Toast";
import CommonFunctions from "../../Utils/CommonFunctions";
import { Helmet } from "react-helmet";
import HTTPRequest from "../../Utils/HTTPRequest";
import copy from "copy-to-clipboard";
import { isMobile } from "react-device-detect";

function ModelBuilder() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [copyText, setCopyText] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  // const currentURL = window.location.href;
  //const pathname = window.location.pathname;
  // const protocol = window.location.protocol;
  // const hostname = window.location.hostname;
  const languageSite = CommonFunctions.getSelectedLanguage();
  const strHelmet = Helmet.title;
  const [citeType, setCiteType] = useState("Harward");
  const [CitetionInfo, setCitetionInfo] = useState(
    document.title + ":" + window.location.href
  );
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [CiteTitle, setCiteTitle] = useState(document.title);
  const [EmailID, setEmailID] = useState("");
  const [CiteURL, setCiteURL] = useState(window.location.href);
  const [Annotation, setAnnotation] = useState("");
  const [citeLocation, setCiteLocation] = useState(""); //() =>{
  //return "";

  //};
  const [ip, setIP] = useState("");

  // const handleCopyText = (e) => {
  //     setCopyText(e.target.value);
  // }

  const copyToClipboard = (e) => {
    if (copyText) {
      setAnnotation(false);
      setSubmitMessage("");
    } else {
      copy(CitetionInfo);
      setAnnotation(true);
      setSubmitMessage(t("copied"));
    }

    //setMessage(`You have copied "${CitetionInfo}"`);
  };

  const getIPConfig = async () => {
    try {
      HTTPRequest.getJson(
        "https://api.ipify.org/?format=json",
        false,
        function (result) {
          setIP(result.ip);
          setCiteLocation(result.ip);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    //passing getData method to the lifecycle method
    getIPConfig();
  }, []);

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      HTTPRequest.getJson(
        process.env.REACT_APP_AtlasWSurl +
          "UserRequestSubmit?strFirstName=" +
          FirstName +
          "&strLastName=" +
          LastName +
          "&strMobileNumber=" +
          "" +
          "&strEMail=" +
          EmailID +
          "&strCiteType=" +
          citeType +
          "&strciteTitle=" +
          CiteTitle +
          "&strciteUrl=" +
          CiteURL +
          "&strciteAnnotation=" +
          Annotation +
          "&strfullCitetionInfo=" +
          CitetionInfo +
          "&strClientLocation=" +
          ip,
        false,
        function (result) {
          e.target.elements.frmFirstName.value = "";
          e.target.elements.frmLastName.value = "";
          e.target.elements.frmEmailID.value = "";
          // e.target.elements.message.value = '';
          if (result == "True") {
            setSubmitMessage(t("CitetionSubmittedSuccess"));
            //e.target.elements.btnMessage.=true;
          } else {
            setSubmitMessage(t("CitetionSubmittedfailed"));
          }
          //e.target.elements.btnMessage.display=true;
        }
      );
    } catch (err) {
      console.log(err);
    } finally {
      this.handleClose();
    }
  };

  let handleCloseModel = () => {
    setSubmitMessage("");
    handleClose(true);
  };

  // function submitCitetion(e){
  //     e.preventDefault();
  //     console.log('firstname:%s lastname: %s',frmFirstName,frmLastName);
  //     const strFirstName=e.target.elements.frmFirstName.value;
  //     const strLastName=e.target.elements.frmLastName.value;
  //     const strEmailID=e.target.elements.frmEmailID.value;
  //     //const strUniversity=e.target.elements.frm.value;
  //     const strCiteType=e.target.elements.frmCiteType.value;
  //     const strCitetionInfo=e.target.elements.frmCitetionInfo.value;
  //     const strCiteURL=e.target.elements.frmCiteURL.value;
  //     const strCiteTitle=e.target.elements.frmCiteTitle.value;
  //     const strAnnotation=e.target.elements.frmAnnotation.value;

  // }

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
      <i class="fa-solid fa-quote-right"></i> {t("citeme")}
      </Button> */}
      <div>
        <div
          id="citeform"
          onClick={handleShow}
          className={
            isMobile
              ? "form_citebtn sidebar-anchor menuclose form_citebtn_mbl"
              : "form_citebtn sidebar-anchor menuclose"
          }
        >
          <i class="fa-solid fa-quote-right"></i>{" "}
          <Trans i18nKey="citeme"></Trans>
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          dir={languageSite == "ar" ? "rtl" : "ltr"}
          className="mo_pop"
        >
          <Modal.Header>
            <Modal.Title>
              {/* Atlas Citetion submit form */}
              {<Trans i18nKey="citetionHeader"></Trans>}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="mo_pop_div">
            <Form
              className="form_citesubmit"
              id="frm_citetioninfo"
              onSubmit={handleSubmit}
              dir={<Trans i18nKey="direction"></Trans>}
            >
              <Form.Group className="cite_lab" controlId="formBasicEmail">
                <Form.Label>
                  {" "}
                  {<Trans i18nKey="citetiontype"></Trans>}
                </Form.Label>
                <Form.Select
                  aria-label="Default select example"
                  name="frmCiteType"
                  onChange={(e) => setCiteType(e.target.value)}
                >
                  <option value="APA 7">APA 7</option>
                  <option value="Harvard" selected>
                    Harvard
                  </option>
                  <option value="chicago">chicago</option>
                  <option value="IEEE">IEEE</option>
                  <option value="MLA">MLA</option>
                </Form.Select>
                <Form.Label>
                  {" "}
                  {<Trans i18nKey="citetionFirstName"></Trans>}{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("citetionFirstName")}
                  name="frmFirstName"
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                  maxLength={50}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a firstname.
                </Form.Control.Feedback>
                <Form.Label>
                  {<Trans i18nKey="citetionLastName"></Trans>}{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("citetionLastName")}
                  name="frmLastName"
                  onChange={(e) => setLastName(e.target.value)}
                  required
                  maxLength={50}
                />

                <Form.Label>
                  {<Trans i18nKey="citetionTitle"></Trans>}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("citetionTitle")}
                  name="frmCiteTitle"
                  onChange={(e) => setCiteTitle(e.target.value)}
                  required
                  value={CiteTitle}
                  maxLength={50}
                />

                <Form.Label>
                  {<Trans i18nKey="citetionEmail"></Trans>}{" "}
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder={t("citetionEmail")}
                  name="frmEmailID"
                  onChange={(e) => setEmailID(e.target.value)}
                  required
                  maxLength={50}
                />

                <Form.Label>{<Trans i18nKey="citetionURL"></Trans>}</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("citetionURL")}
                  name="frmCiteURL"
                  onChange={(e) => setCiteURL(e.target.value)}
                  readOnly
                  value={CiteURL}
                />

                <Form.Label>
                  {<Trans i18nKey="citetionAnnotation"></Trans>}
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t("citetionAnnotation")}
                  name="frmAnnotation"
                  onChange={(e) => setAnnotation(e.target.value)}
                  maxLength={200}
                />
              </Form.Group>
              <Form.Group className="cit_box" controlId="formBasicEmail">
                <Form.Label className="cit_full">
                  {" "}
                  {<Trans i18nKey="citetionURLDetails"></Trans>}{" "}
                </Form.Label>
                <span
                  id="btnCopy"
                  className="btn_cpy"
                  onClick={copyToClipboard}
                >
                  <i class="fa fa-copy"></i>
                </span>
                <Form.Text className="text-muted" id="frmCitetionInfo">
                  <h6>{CitetionInfo}</h6>
                  {/* <button onClick={copyToClipboard}>copy</button> */}
                </Form.Text>
              </Form.Group>
            </Form>
            <Modal.Footer
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <button
                variant="secondary"
                onClick={handleCloseModel}
                className="cit_btn_box btn_cl"
              >
                {t("close")}{" "}
              </button>

              {/* <Button variant="primary" form='citetionForm'></Button> */}
              <button
                variant="primary"
                form="frm_citetioninfo"
                className="cit_btn_box btn_su"
              >
                {t("submit")}{" "}
              </button>
              <div
                name="btnMessage"
                id="btnMessage"
                className="mt-5 alert alert-success"
                hidden={submitMessage.length > 0 ? false : true}
              >
                {submitMessage}
              </div>
              {/* <Toast className='alert alert-success'>                           
                            <Toast.Body>{submitMessage}</Toast.Body>
                            </Toast> */}
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default ModelBuilder;
